<template>
  <div class="input-date"
    :class="getTypeClasses">
    <label :for="id">
      {{label}}
    </label>
    <div class="input-container">
      <input :id="id" type="date" :title="label" v-bind="$attrs" v-on="$listeners" />
      <icon-base class="icon"><icon-calendar/></icon-base>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.input-date {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  input {
    width: 100%;
    padding-right: 2rem;
  }
  &.row {
    label {
      visibility: hidden;
      height: 0;
    }
    input {
      width: 100%;
    }
  }
  .icon {
    pointer-events: none;
  }
}

label {
  font-size: var(--text--xs);
}

</style>

<script>
import { v4 as uuid } from 'uuid'
import IconBase from '@/components/icons/IconBase'
import IconCalendar from '@/components/icons/IconCalendar'

export default {
  inheritAttrs: false,
  components: {
    'icon-base': IconBase,
    'icon-calendar': IconCalendar
  },
  props: {
    id: {
      type: String,
      default () {
        return uuid()
      }
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    getTypeClasses () {
      switch (this.type) {
        case 'vertical':
          return 'vertical'
        case 'row':
          return 'row'
        default:
          return ''
      }
    }
  }
}
</script>
